function createShareUrl({ text, url }) {
  return `https://threema.id/compose?text=${text}&url=${url}`
}

export default {
  id: 'threema',
  title: 'Threema',
  createShareUrl
}
